import { NGBAddress } from '../constants/fields';

type ThanksInstructionsProps = { isCarrierEnabled: boolean; pdf?: string };

const ThanksInstructions = ({ isCarrierEnabled, pdf }: ThanksInstructionsProps) => {
  return isCarrierEnabled ? (
    <>
      <p>
        Ecco l&apos;etichetta per la tua spedizione:{' '}
        <span className="text-bold">
          <a target="new" href={pdf}>
            Etichetta
          </a>
        </span>
      </p>
      <p>Dovresti stamparla e attaccarla al tuo pacco da consegnare al corriere.</p>
    </>
  ) : (
    <>
      <p>Ecco l&apos;indirizzo dove dovrai spedire il tuo campione:</p>
      <p>
        <span className="font-bold">{NGBAddress}</span>
      </p>
    </>
  );
};

export default ThanksInstructions;
